<div class="alert-box">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onCloseModal()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">{{ "delete_saved_block" | translate }}</h4>
    </div>
    <div class="modal-body">
        <p>
            {{ "delete_saved_block_message" | translate }}
        </p>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="onCancel()">
            {{ "cancel" | translate }}
        </button>
        <button type="button" class="btn btn-danger" (click)="onConfirm()">
            {{ "delete" | translate }}
        </button>
    </div>
</div>
